import React, { Component } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';

import Box from '../../../components/UI/Box';
import CollapsableRow from '../../../components/CollapsableRow';
import { API_URL, ERROR_HANDLE } from '../../../config/constants';
import Button from "../../../components/UI/Button";
import AddAdmin from "./AddAdmin";

import IC_EDIT from '../../../assets/images/iconEdit.svg';
import IC_DELETE from '../../../assets/images/waste-bin.png';

const labels = ['Name', 'Email', 'Access Level', 'Actions'];

export default class Admins extends Component {

    constructor() {
        super();
        this.state = {
            showAddAdmin: false,
            editDetails: null,
            admins: [],
        };
    }

    headerItems = labels.map((label, i) => {
        return (
            <p style={style.titleItem} key={i}>
                {label}
            </p>
        );
    });

    header = () => <div style={style.titleWrapper}>{this.headerItems}</div>;

    fetchAdmins = () => {
        const access_token = localStorage.getItem('access_token');
        const toastId = toast('Fetching...');
        axios
            .get(`${API_URL}/admin/`, {
                headers: {
                    'x-access-token': access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                this.setState({
                    admins: res.data.admins,
                });
            })
            .catch(err => {
                toast.dismiss(toastId);
                ERROR_HANDLE(err);
            });
    }

    deleteAdmin = (email) => {
        const access_token = localStorage.getItem('access_token');
        const toastId = toast('Deleting...');
        axios
            .delete(`${API_URL}/admin/${email}`, {
                headers: {
                    'x-access-token': access_token
                }
            })
            .then(res => {
                toast.dismiss(toastId);
                setTimeout(() => this.fetchAdmins(), 500);
            })
            .catch(err => {
                toast.dismiss(toastId);
                ERROR_HANDLE(err);
            });
    }

    componentDidMount() {
        this.fetchAdmins();
    }

    addAdmin() {
        this.setState({ showAddAdmin: true });
    }

    editAdmin = (admin) => {
        this.setState({
            showAddAdmin: true,
            editDetails: admin
        });
    }

    renderItem = (currentItem, index) => {
        let persistent = (
            <div>
                <hr style={{ borderTop: '1px solid #b5b5b6', borderRadius: '0.5px' }} />
                <div style={style.itemWrapper}>
                    <p style={{ ...style.item }}>{currentItem.name}</p>
                    <p style={{ ...style.item }}>{currentItem.email}</p>
                    <p style={{ ...style.item }}>{currentItem.access_level}</p>
                    <div style={{ ...style.item }}>
                        <img
                            onClick={(e) => {
                                e.stopPropagation()
                                this.editAdmin(currentItem);
                            }}
                            src={IC_EDIT}
                            style={style.actionImage}
                        />
                        <img
                            onClick={(e) => {
                                e.stopPropagation()
                                this.deleteAdmin(currentItem.email);
                            }}
                            src={IC_DELETE}
                            style={style.actionImage}
                        /></div>
                </div>
            </div>);
        return <CollapsableRow data={{ persistent }} key={index} />
    }

    render() {
        return (
            <div style={style.wrapper}>
                <Button type="primary" style={style.button} onClick={(e) => {
                    e.stopPropagation()
                    this.addAdmin();
                }}>Add Admin</Button>
                <Box style={style.box} outline>
                    {this.header()}
                    {this.state.admins.map((currentItem, index) => {
                        return this.renderItem(currentItem, index)
                    })}
                </Box>
                {
                    this.state.showAddAdmin && <AddAdmin
                        editDetails={this.state.editDetails}
                        onUpdate={this.fetchAdmins}
                        close={() => {
                            this.setState({
                                showAddAdmin: false,
                                editDetails: null,
                            })
                        }} />
                }

            </div>
        );
    }
}

const style = {
    titleWrapper: {
        display: 'flex'
    },
    titleItem: {
        flex: '1',
        fontSize: '20px',
        color: '#00b4d2'
    },
    box: {
        width: '1000px',
        margin: '10px',
    },
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10px',
        flexDirection: 'column',
        alignItems: 'center'
    },
    button: {
        alignSelf: "center",
        width: "220px",
        height: "50px",
        fontSize: "18px",
    },
    actionImage: {
        marginLeft: 10,
        width: 30,
        height: 30,
    },
    itemWrapper: {
        display: 'flex',
        width: '100%',
        alignItems: 'center'
    },
    item: {
        flex: '1'
    },
};
